import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button, Modal } from 'antd'

import { openModalCreateChannel, requestCreateChannel, closeModalCreateChannel } from 'redux/Rooms/actions'

import FormCreateChannel from './FormCreateChannel'

class ModalButtonCreateChannel extends React.Component {
    showModalChannel = () => {
        this.props.openModal()
    }

    handleCancel = () => {
        this.props.closeModal()
    }

    createChannel = params => {
        const { channel } = params
        const args = channel && channel != '' ? { room_id: channel } : {}

        const { createChannel } = this.props

        createChannel(args)
    }

    render() {
        const { loadingRequest, visible } = this.props

        return (
            <div>
                <Button onClick={this.showModalChannel} type="primary">
                    Create
                </Button>
                <Modal title="Create Channel" visible={visible} footer={null} onCancel={this.handleCancel}>
                    <FormCreateChannel onSubmit={this.createChannel} loadingAnswer={loadingRequest} />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = ({ rooms }) => ({
    visible: rooms.visibleCreateChannelModal,
    loadingRequest: rooms.loadingCreateChannel
})

const mapActionsToProps = dispatch => ({
    openModal: bindActionCreators(openModalCreateChannel, dispatch),
    closeModal: bindActionCreators(closeModalCreateChannel, dispatch),
    createChannel: bindActionCreators(requestCreateChannel, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(ModalButtonCreateChannel)
